export const SECTION_TYPES = {
  LINK_SECTION: "StoreLocatorFacilityExtraInfoSectionLink"
};
